import * as React from "react";
import { getHomePolicies, isValidHomePolicy, } from "../../services/connect/utils";
import BasePoliciesLoadingRoute from "../../features/policies/routes/policies-loading";
import { PHASE } from "../../routeConfig";
import useAffiliateConfig from "../../hooks/useAffiliateConfig";
import useAppSelector from "../../hooks/useAppSelector";
import useMemoryHistory from "../../hooks/useMemoryHistory";
export default function HomePoliciesLoadingRoute() {
    var _a = useAppSelector(function (state) { return state.auth.home.accountInfo; }), connectionId = _a.connectionId, temporaryAccessKey = _a.temporaryAccessKey;
    var push = useMemoryHistory().push;
    var quotesOnly = useAffiliateConfig().quotesOnly;
    var onPoliciesLoaded = React.useCallback(function (policyResponse) {
        var homePolicy = getHomePolicies(policyResponse.policies)[0];
        var hasValidHomePolicy = isValidHomePolicy(homePolicy);
        var nextRoutes = {
            validPolicy: PHASE.HOME_POLICIES_LOADED,
            invalidPolicy: PHASE.QUOTE_LOADING,
        };
        if (hasValidHomePolicy) {
            push(nextRoutes.validPolicy);
        }
        else {
            push(quotesOnly
                ? PHASE.HOME_POLICIES_MISSING_DATA
                : nextRoutes.invalidPolicy);
        }
    }, [push, quotesOnly]);
    return (React.createElement(BasePoliciesLoadingRoute, { connectionId: connectionId, temporaryAccessKey: temporaryAccessKey, onPoliciesLoaded: onPoliciesLoaded }));
}
